export class UserNotification {
    equipeId: string;
    remetenteId: number;
  }